import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';
import moment from 'moment';
import { Pharmacy } from './Pharmacy';

export const Protection = types.compose(
  'Protection',
  BaseEntity,
  types.model({
    protectionId: types.integer,
    pharmacyId: types.maybe(types.integer),
    apbNumber: types.maybe(types.string),
    status: types.maybe(types.string),
    // pharmacy: Pharmacy,
    startDate: types.optional(types.string, moment().format()),
    endDate: types.optional(types.string, moment().format()),
    duration: types.maybe(types.integer),
    durationUom: types.maybe(types.string),
    type: types.maybe(types.string),
    range: types.maybe(types.integer),
    rangeUom: types.maybe(types.string),
}),
);

